import {translate} from '@utils/languageTools';

export enum StaticPasteSpecial {
  ContactType = 'ContactType',
  VatZone = 'VatZone',
}
export function InitializeStaticPasteSpecialDefinitions() {
  setContactType();
  setVatZone();
}

function setContactType() {
  global.pasteSpecials[StaticPasteSpecial.ContactType] = [
    {Code: '0', Comment: translate('Company')},
    {Code: '1', Comment: translate('Person')},
  ];
}

function setVatZone() {
  global.pasteSpecials[StaticPasteSpecial.VatZone] = [
    {Code: '0', Comment: translate('Domestic')},
    {Code: '1', Comment: translate('InsideEU')},
    {Code: '2', Comment: translate('InsideEUPostVat')},
    {Code: '3', Comment: translate('OutsideEU')},
    {Code: '4', Comment: translate('OutsideEUPostVat')},
  ];
}
